import { render, staticRenderFns } from "./SelectCompliancePopup.vue?vue&type=template&id=4e857023&scoped=true"
import script from "./SelectCompliancePopup.vue?vue&type=script&lang=js"
export * from "./SelectCompliancePopup.vue?vue&type=script&lang=js"
import style0 from "./SelectCompliancePopup.vue?vue&type=style&index=0&id=4e857023&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e857023",
  null
  
)

export default component.exports